module.exports = __webpack_public_path__ + "assets/img/1.3ec0e72c.png";